import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-md p-4 md:p-5 lg:p-6 transition-smooth hover-lift"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={20} color={stat?.iconColor} strokeWidth={2} />
            </div>
            {stat?.trend && (
              <div className={`flex items-center gap-1 px-2 py-1 rounded-full ${stat?.trend > 0 ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}`}>
                <Icon name={stat?.trend > 0 ? 'TrendingUp' : 'TrendingDown'} size={14} />
                <span className="text-xs font-medium data-text">
                  {Math.abs(stat?.trend)}%
                </span>
              </div>
            )}
          </div>
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground data-text">
            {stat?.value}
          </p>
          <p className="text-xs md:text-sm text-muted-foreground mt-1 caption">
            {stat?.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;